import React, { useContext, useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import * as yup from 'yup';
import { findValidationMessage } from '@utils/validation';
import { ApiContext } from '@api/api.tsx';
import { CarriersInToGroupIds, LovDTO } from '@api/ringil-api.v2';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import useForm from '@hooks/useForm/useForm.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  carrierGroupId: string;
  onComplete: () => void;
}

const AddCarrierToGroup: React.FC<ComponentProps> = ({ visible, onHide, carrierGroupId, onComplete }) => {
  const { tr } = useTranslationLgs();
  const { cuAddCarrierToGroup, cuLoVCarrierForGroup } = useContext(ApiContext);
  const [loading, setLoading] = useState(false);
  const [availableCarriers, setAvailableCarriers] = useState<LovDTO[]>(undefined);

  useEffect(() => {
    if (visible) {
      cuLoVCarrierForGroup(carrierGroupId, data => {
        setAvailableCarriers(data.carriers);
      });
      form.setFieldValue(form.names.carrierIds, []);
    }
  }, [visible]);

  const schema = yup.object().shape({
    carrierIds: yup.array().min(1).required(),
  });

  const onContinueHandler = (data: CarriersInToGroupIds) => {
    console.log(data);
    setLoading(true);
    cuAddCarrierToGroup(
      carrierGroupId,
      data,
      () => {
        setLoading(false);
        onComplete();
      },
    );
  }

  const form = useForm<CarriersInToGroupIds>(
    schema,
    { carrierIds: [] },
    (d) => onContinueHandler(d),
    false,
    false,
    () => {
    },
    'none',
  );

  return (
    <>
      <RingilSidebar
        heading={tr(`AddCarrierToGroup.addCarriersToThisGroup`, `Add carriers to this group`)}
        visible={visible}
        onBack={onHide}
        onContinue={() => form.validateAndSend()}
        loading={loading}
      >
        {availableCarriers && (
          <Field
            label={tr(`AddCarrierToGroup.carrierName`, `Carrier name`)}
            required
            errorMessage={findValidationMessage(form.validationErrors, form.names.carrierIds, tr)}
          >
            <MultiSelect
              display="chip"
              value={form.values.carrierIds}
              options={availableCarriers}
              onChange={e => {
                form.setFieldValue('carrierIds', e.value);
              }}
              optionLabel="name"
              optionValue="id"
              filter
            />
          </Field>
        )}
      </RingilSidebar>
    </>
  );
};

export default AddCarrierToGroup;
